module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a299dfce333bc76558e0bd663bddf0c9.gif";